import { useEffect } from 'react';

/**
 * Globally disables:
 * - Text selection
 * - Right-click context menu
 * - Browser DevTools shortcuts (F12, Ctrl+Shift+I, Ctrl+Shift+J, Ctrl+U, Ctrl+S)
 *
 * Mount in any exam-related page to prevent casual inspection/copying.
 */
export function useAntiCheat(enabled = true) {
  useEffect(() => {
    if (!enabled) return;

    const blockContextMenu = (e: MouseEvent) => e.preventDefault();

    const blockSelectStart = (e: Event) => e.preventDefault();

    const blockDevTools = (e: KeyboardEvent) => {
      const key = e.key?.toUpperCase();
      const ctrl = e.ctrlKey || e.metaKey;

      // F12
      if (key === 'F12') {
        e.preventDefault();
        return;
      }
      // Ctrl+Shift+I / Ctrl+Shift+J (DevTools panel)
      if (ctrl && e.shiftKey && (key === 'I' || key === 'J')) {
        e.preventDefault();
        return;
      }
      // Ctrl+U (View Source)
      if (ctrl && key === 'U') {
        e.preventDefault();
        return;
      }
      // Ctrl+S (Save page)
      if (ctrl && key === 'S') {
        e.preventDefault();
        return;
      }
      // Ctrl+A (Select All)
      if (ctrl && key === 'A') {
        e.preventDefault();
      }
    };

    document.addEventListener('contextmenu', blockContextMenu);
    document.addEventListener('selectstart', blockSelectStart);
    document.addEventListener('keydown', blockDevTools);

    // CSS-level: disable user-select on the document
    document.documentElement.style.userSelect = 'none';

    return () => {
      document.removeEventListener('contextmenu', blockContextMenu);
      document.removeEventListener('selectstart', blockSelectStart);
      document.removeEventListener('keydown', blockDevTools);
      document.documentElement.style.userSelect = '';
    };
  }, [enabled]);
}
